import { useEffect, useRef, useState } from 'react'
import { Animated } from 'react-native'

const PLACEHOLDER_SUGGESTIONS = [
  'High-protein lunch ideas',
  'Low-spike dinner ideas',
  'Why did lunch spike me?',
  'Best snacks for stable glucose',
  'How does sleep affect glucose?',
  'What to eat pre-workout?',
]

const PLACEHOLDER_INTERVAL = 4000
const FADE_DURATION = 300

export const usePlaceholderRotation = () => {
  const [index, setIndex] = useState(0)
  const opacity = useRef(new Animated.Value(1)).current

  useEffect(() => {
    const interval = setInterval(() => {
      Animated.timing(opacity, {
        toValue: 0,
        duration: FADE_DURATION,
        useNativeDriver: true,
      }).start(() => {
        setIndex((prev) => (prev + 1) % PLACEHOLDER_SUGGESTIONS.length)
        Animated.timing(opacity, {
          toValue: 1,
          duration: FADE_DURATION,
          useNativeDriver: true,
        }).start()
      })
    }, PLACEHOLDER_INTERVAL)
    return () => clearInterval(interval)
  }, [opacity])

  return { text: PLACEHOLDER_SUGGESTIONS[index], opacity }
}
